module.exports = __webpack_public_path__ + "img/MGH-Nakasu-2.903fa2bf.jpg";